import {useDispatch, useSelector} from "react-redux";
import {notification} from "antd";
import {useEffect} from "react";
import {Button, Icon, Loading} from "../../../components";
import {PromotionTable} from "../components";
import {
    promotionActions,
    promotionErrorSelector,
    promotionFilterSelector,
    promotionItemsSelector,
    promotionLoadingSelector,
    promotionPaginationSelector
} from "../promotionSlice";
import ActionBar from "../../../layout/ActionBar";
import {useCan} from "../../../hooks";


function Promotion()
{
    const can = {
        add: useCan('promotionAdd'),
        edit: useCan('promotionEdit'),
        delete: useCan('promotionDelete'),
    };

    const dispatch = useDispatch();

    const items = useSelector(promotionItemsSelector)

    const loading = useSelector(promotionLoadingSelector)

    const error = useSelector(promotionErrorSelector)

    const pagination = useSelector(promotionPaginationSelector)

    const filter = useSelector(promotionFilterSelector)

    const eventsHandler = {
        load: () =>
        {
            dispatch(promotionActions.fetchData({
                ...filter,
                detail: ['user']
            }))
        },
        changePagination: (page) =>
        {
            dispatch(promotionActions.setFilter({
                ...filter, page, detail: ['user']
            }))
        },
    }

    useEffect(() => {
        eventsHandler.load()
    }, [filter])

    if(error)
    {
        notification.error({
            message: 'Có lỗi xảy ra',
            description: error,
        })
    }

    return (
        <>
            <ActionBar title={'Chương trình khuyến mãi'}>
                {can.add && <Button outline leftIcon={Icon.plusCircle} green to={`/promotion/add`}>Thêm mới</Button>}
                <Button outline small onClick={eventsHandler.load} style={{fontSize:'20px'}}>{Icon.reload}</Button>
            </ActionBar>
            <div className="container">
                <div className="content">
                    {loading && <Loading noFixed spin />}
                    {(!loading && items) && <PromotionTable
                        items={items}
                        pagination={pagination}
                        onPaginationChange={eventsHandler.changePagination}
                        can={can}
                    />}
                </div>
            </div>
        </>

    )
}

export default Promotion;